/**
 * @file Workaround for Safari not loading lazy images when printing.
 * @see https://bugs.webkit.org/show_bug.cgi?id=224547
 */

import { $$ } from '../../utils/dom.ts';

window.addEventListener('beforeprint', () => {
    $$('[loading=lazy').forEach(($el) => {
        $el.removeAttribute('loading');
    });
});
